var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 23.83 16.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#1c3152;}.cls-4{stroke:#39af4f;stroke-miterlimit:10;stroke-width:1.3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 23.83,
    height: 16.77
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.19,4.55l.6-1a.73.73,0,0,0-.24-1,.76.76,0,0,0-.38-.11.71.71,0,0,0-.61.35L18,3.75c.42.26.82.52,1.2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.24,3.31l.37-1a.71.71,0,0,0-.4-.93.86.86,0,0,0-.27,0,.71.71,0,0,0-.66.46l-.35.86a12.08,12.08,0,0,1,1.31.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.57,7.38c.29-.31.62-.66,1-1l-1.11-1A.66.66,0,0,0,1,5.19a.72.72,0,0,0-.54.25.7.7,0,0,0,.06,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.58,7.66l.76-.6a.73.73,0,0,0,.12-1,.75.75,0,0,0-.57-.28.71.71,0,0,0-.45.16l-.86.69c.38.37.72.73,1,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.09,2.37l.17-.85A.71.71,0,0,0,14.7.68l-.15,0a.72.72,0,0,0-.7.58L13.69,2a11.05,11.05,0,0,1,1.4.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21,6l.76-.86a.71.71,0,0,0-.07-1A.69.69,0,0,0,21.18,4a.71.71,0,0,0-.54.24l-.77.87c.39.31.75.63,1.09.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3.16,5.81c.34-.31.72-.62,1.11-.93l-.9-1.13a.74.74,0,0,0-.57-.27.73.73,0,0,0-.45.16.72.72,0,0,0-.11,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.92,4.4c.38-.28.79-.54,1.21-.79L5.51,2.48a.71.71,0,0,0-.63-.38.73.73,0,0,0-.63,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.87,3.2a12,12,0,0,1,1.31-.61l-.33-1a.72.72,0,0,0-.68-.49.62.62,0,0,0-.23,0,.71.71,0,0,0-.45.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.43,2l-.13-.83A.72.72,0,0,0,9.59.53h-.1a.72.72,0,0,0-.61.82L9,2.3A11.11,11.11,0,0,1,10.43,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.94,1.83c.29,0,.56,0,.84,0l0-.76a.72.72,0,0,0-.7-.74h0a.72.72,0,0,0-.72.7l0,.79c.2,0,.4,0,.6,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.94,1.83c6.38,0,11.4,6.73,11.61,7l.31.43-.31.43c-.21.28-5.23,7-11.61,7S.55,10,.34,9.7L0,9.27l.31-.43c.21-.28,5.22-7,11.6-7M22.05,9.27c-1.18-1.44-5.32-6-10.11-6S3,7.83,1.84,9.27c1.18,1.44,5.32,6,10.1,6s8.93-4.56,10.11-6"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.94,
    cy: 9.39,
    r: 3.59
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/open-eye.f3d45985ac759a6051fe83dd5268bcce.svg";
export { ForwardRef as ReactComponent };